module.exports = __webpack_public_path__ + "img/14ry_tp01.45133ddb.jpg";